import {
  Box,
  Fade,
  Modal,
  Paper,
  TextField,
  Typography,
  IconButton,
  Button,
  Autocomplete,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { AddBox } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { useEffect, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { createAccountGroupMaster, updateAccountGroupMaster } from '../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  width: { xs: '80vw', md: '50vw' },
};
const NewAddPartyGroup = ({ open, setOpen, viewOpen, setNewGp, options, getAccountData, editData, setEditData }) => {
  const [group, setGroup] = useState(editData?.pgID || options[0].value);
  const [errorBool, setErrorBool] = useState(false);
  const [groupName, setGroupName] = useState(editData?.label ? editData?.label : '');
  const [backdropOpen, setBackdropOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
      setEditData('');
    }
  };
  async function createPartyGroup(data) {
    setBackdropOpen(true);
    try {
      if (!editData) {
        const res = await API.graphql(
          graphqlOperation(createAccountGroupMaster, {
            createAccountGroupMasterInput: data,
          })
        );
        if (res?.data?.createAccountGroupMaster.statuscode === 'SUCCESS') {
          setNewGp(res?.data?.createAccountGroupMaster.accountgroupid);
          setOpen(false);
          viewOpen(false);
          showSuccessSnackbar('Group Created Successfully');
          getAccountData();
        }
      } else {
        const res = await API.graphql(
          graphqlOperation(updateAccountGroupMaster, {
            updateAccountGroupMasterInput: data,
          })
        );

        if (res?.data?.updateAccountGroupMaster?.statuscode == 'Success') {
          setOpen(false);
          viewOpen(false);
          showSuccessSnackbar(res?.data?.updateAccountGroupMaster?.statusmessage);
          getAccountData();
          setEditData('');
        }
      }
    } catch (error) {
      if (error) {
        const rawMessage = error?.errors[0]?.message?.split('RDSHttp:')[1];
        const parsedMessage = JSON.parse(rawMessage)?.message;
        const errorMessage = parsedMessage?.split('ERROR: ')[1]?.split(';')[0];
        showWarningSnackbar(errorMessage);
      }
    }
    setBackdropOpen(false);
  }

  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === 's') {
        if (errorBool || groupName === '') {
          e.preventDefault();
        } else {
          e.preventDefault();
          addGroup();
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [group, groupName]);

  const addGroup = () => {
    const groupData = {
      accountgroupname: groupName,
      accountparentgroupid: group,
      accounttypecd: 'BS',
    };
    const updateData = {
      accountgroupid: Number(editData?.value),
      accountgroupname: groupName,
      companybranchid: 0,
      accountparentgroupid: Number(group),
      accounttypecd: 'BS',
      is_active: 1,
    };
    if (editData) {
      createPartyGroup(updateData);
    } else {
      createPartyGroup(groupData);
    }
  };
  return (
    <Modal
      id={open ? 'addPartyGroup' : ''}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ color: '#fff', display: 'flex' }}>
                  {' '}
                  <AddBox fontSize="small" sx={{ marginRight: '5px' }} /> {editData?.value ? 'Edit Group' : 'New Group'}
                </Typography>
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: '#fff' }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '15px',
            }}
          >
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: { xs: 1 }, m: 1 }}>
                <TextField
                  name="group"
                  placeholder="Group"
                  size="small"
                  type="text"
                  fullWidth
                  value={groupName}
                  required={true}
                  onChange={(e) => {
                    if (e.target.value.trim().length < 40) {
                      // Capitalize first letter of each word
                      const capitalizedValue = e.target.value
                        .split(' ')
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(' ');

                      setGroupName(capitalizedValue);
                      const data = options.find((op) => op.label.toLowerCase() == capitalizedValue.trim().toLowerCase());
                      if (data) {
                        setErrorBool(true);
                      } else {
                        setErrorBool(false);
                      }
                    }
                  }}
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '20px',
                      fontWeight: 'bold',
                    },
                  }}
                />
                <Autocomplete
                  fullWidth
                  sx={{ marginTop: '10px' }}
                  getOptionLabel={(option) => option?.label}
                  value={options?.find((op) => op?.value == group) || null}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setGroup(newValue.value);
                  }}
                  size="small"
                  options={options}
                  renderInput={(params) => <TextField {...params} fullWidth label="Under Parent Group" />}
                />
                {errorBool ? (
                  <Typography
                    sx={{
                      marginTop: '2px',
                      marginLeft: '10px',
                      marginBottom: '0px',
                      fontSize: '12px',
                      color: 'danger.main',
                    }}
                  >
                    Group exists
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      padding: '10px',
                      fontSize: '12px',
                      color: 'danger.main',
                    }}
                  ></Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Button onClick={handleClose} variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
              Cancel
            </Button>
            <LoadingButton
              sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
              variant="contained"
              onClick={addGroup}
              disabled={errorBool || groupName === ''}
            >
              {editData ? 'Update' : 'Save'}
            </LoadingButton>
          </Box>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default NewAddPartyGroup;
